class Deficoin {
  defiImg = ''
  defiCoinType
  rate
  buyMinNum
  buyMaxNum
  totalFinancing
  constructor(defiCoinType) {
    this.defiImg = '2332'
    this.defiCoinType = defiCoinType
    this.rate = 0
    this.buyMinNum = 0
    this.buyMaxNum = 0
    this.totalFinancing = 0
  }
}

export { Deficoin }
